/** @format */

import React from 'react';
import GeneralDialog from '../../../components/Dialog/GeneralDialog';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import I18n from '../../../components/Translate/I18n';
import { ServiceListUploadInterface } from './ServiceListUploadInterface';

interface PrefixUploadReportViewInterface {
    serviceListUpload: ServiceListUploadInterface | null;
    closeReportView: () => void;
}

const REPORT_SERVICE_LIST_MODIFIED = 'report_service_list_modified';
const REPORT_SERVICE_LIST_ADDED = 'report_service_list_added';
const REPORT_SERVICE_LIST_ERROR = 'report_service_list_error';
const REPORT_SERVICE_LIST_SKIPPED = 'report_service_list_skipped';

const ServiceListUploadReportView: React.FC<PrefixUploadReportViewInterface> = (props) => {
    const { serviceListUpload, closeReportView } = props;

    const reportContent = serviceListUpload?.reportMessage ? JSON.parse(serviceListUpload.reportMessage) : null;

    return (
        <GeneralDialog
            title={'prefixes:report.import_view'}
            dialogType={'info'}
            open={!!serviceListUpload}
            disagreeCallback={closeReportView}
            maxWidth={'lg'}
            fullWidth
        >
            {reportContent && (
                <>
                    <GridContainer>
                        <GridItem xs={3}>
                            <I18n trans={`prov:report.${REPORT_SERVICE_LIST_ADDED}`} />
                        </GridItem>
                        <GridItem xs={9}>{reportContent['created']}</GridItem>

                        <GridItem xs={3}>
                            <I18n trans={`prov:report.${REPORT_SERVICE_LIST_MODIFIED}`} />
                        </GridItem>
                        <GridItem xs={9}>{reportContent['updated']}</GridItem>

                        <GridItem xs={3}>
                            <I18n trans={`prov:report.${REPORT_SERVICE_LIST_SKIPPED}`} />
                        </GridItem>
                        <GridItem xs={9}>{reportContent['rejected']}</GridItem>

                        {reportContent['errors'] && reportContent['errors'].length > 0 && (
                            <>
                                <GridItem xs={12}>
                                <strong>  <I18n trans={`prov:report.${REPORT_SERVICE_LIST_ERROR}`} /></strong>
                                </GridItem>
                                {reportContent['errors'].map((error:any, index:any) => (
                                    <GridContainer key={index} spacing={2}>
                                        <GridItem xs={3}>
                                            <strong><I18n trans={`prov:report.line_number`} /> {error.lineNumber}</strong>
                                        </GridItem>
                                        <GridItem xs={9}>
                                            {error.message}
                                        </GridItem>
                                    </GridContainer>
                                ))}
                            </>
                        )}
                    </GridContainer>
                </>
            )}


        </GeneralDialog>
    );
};

export default ServiceListUploadReportView;
